import { useStore } from '../../context/store-context';
import { Box } from '@biom3/react';
import { Department } from '../../../lib/woocomerce/__generated__/graphql';
import { DepartmentButton } from '../department-button';

export const Departments = ({ departments }: { departments: Department[] | undefined }) => {
  const [{ selectedDepartment }, dispatch] = useStore();

  if (!departments || !departments.length) {
    return null;
  }

  const onSelect = (department: Partial<Department>) => {
    dispatch({
      payload: { type: 'SET_SELECTED_DEPARTMENT', selectedDepartment: department as Department }
    });
  };

  return (
    <Box
      key={'departments'}
      sx={{
        my: 'base.spacing.x8',
        display: 'grid',
        gridTemplateColumns: [
          'repeat(auto-fill, minmax(33%, 1fr))',
          'repeat(auto-fill, minmax(33%, 1fr))',
          'repeat(auto-fill, minmax(33%, 1fr))',
          'repeat(auto-fill, minmax(25%, 1fr))'
        ],
        gap: 'base.spacing.x4',
        zIndex: 1,
        position: 'relative'
      }}
    >
      {departments.map((department) => (
        <DepartmentButton
          key={department.id}
          onSelect={onSelect}
          department={department}
          selectedDepartment={selectedDepartment}
        />
      ))}
    </Box>
  );
};
